import * as React from "react";
import { classNames } from "src/common/classNames";

type PropsObjectCardTabPane = {
  className?: string;
  hidden: boolean;
  hiddenClassName: string;
  children: React.ReactNode;
};

export const ObjectCardTabPane: React.FC<PropsObjectCardTabPane> = ({
  className,
  hidden,
  hiddenClassName,
  children,
}) => (
  <div className={classNames([className, [hidden, hiddenClassName]])}>
    {children}
  </div>
);
